/* Notcoy inquiry attribution v1, 2026-10-05. No customer-entered content is read. */
(() => {
  'use strict';
  const script = document.currentScript;
  if (!script || document.documentElement.hasAttribute('data-notcoy-inquiry-loaded')) return;
  document.documentElement.setAttribute('data-notcoy-inquiry-loaded', 'v1');
  const PREFIX = 'notcoy_inquiry_v1_';
  const SOURCE_KEY = PREFIX + 'source';
  const TTL = 90 * 24 * 60 * 60 * 1000;
  const PENDING_TTL = 30 * 60 * 1000;
  const params = new URLSearchParams(location.search);
  const forms = [];
  let source = null;
  let permission = { analytics: false, marketing: false, sharing: false, ready: false };
  const clean = (value, max = 160) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, max);
  const handle = value => /^[a-z0-9][a-z0-9-]{0,99}$/.test(value || '') ? value : '';
  const read = (kind, key) => { try { return JSON.parse(window[kind].getItem(key)); } catch (_) { return null; } };
  const write = (kind, key, value) => { try { window[kind].setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } };
  const remove = (kind, key) => { try { window[kind].removeItem(key); } catch (_) {} };
  const fresh = (record, ttl) => record && Number.isFinite(record.time) && Date.now() >= record.time && Date.now() - record.time < ttl;
  const referrerHost = () => { try { return new URL(document.referrer).hostname; } catch (_) { return ''; } };
  const inquiryId = () => {
    if (window.crypto && window.crypto.randomUUID) return 'NQ-' + window.crypto.randomUUID();
    return 'NQ-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
  };
  const attributionAllowed = () => permission.analytics && permission.marketing && permission.sharing;
  function field(form, label, value) {
    if (!form.querySelector('[data-notcoy-inquiry-type="custom_rug"]')) return;
    let input = form.querySelector('input[data-notcoy-field="' + label + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + label + ']';
      input.setAttribute('data-notcoy-field', label);
      form.appendChild(input);
    }
    input.value = value == null ? '' : String(value);
  }
  function captureSource() {
    if (!attributionAllowed()) {
      source = null;
      if (permission.ready) remove('localStorage', SOURCE_KEY);
      return;
    }
    const saved = read('localStorage', SOURCE_KEY);
    const previous = fresh(saved, TTL) ? saved : null;
    const campaign = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term'].forEach(key => {
      const value = clean(params.get(key));
      if (value && !/@/.test(value)) campaign[key] = value;
    });
    ['gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(key => {
      const value = params.get(key) || '';
      if (/^[A-Za-z0-9_.~-]{1,512}$/.test(value)) campaign[key] = value;
    });
    const host = referrerHost();
    const external = host && !/(^|\.)notcoy\.(com|co)$/i.test(host);
    const signalled = Object.keys(campaign).length > 0 || external;
    const current = { time: Date.now(), landing_path: location.pathname, referrer_host: external ? host : '', campaign };
    // Keep previous non-direct source on direct return visits; do not merge old click IDs into a new source.
    if (!previous || signalled) {
      source = { time: Date.now(), first: previous ? previous.first : current, last: current };
      write('localStorage', SOURCE_KEY, source);
    } else source = previous;
  }
  function fill(state) {
    field(state.form, 'Inquiry reference', state.id);
    field(state.form, 'Inquiry type', state.type);
    field(state.form, 'Rug handle', state.rug);
    field(state.form, 'Inquiry page', location.pathname);
    field(state.form, 'Tracking permissions', JSON.stringify(permission));
    field(state.form, 'Attribution', attributionAllowed() && source ? JSON.stringify(source) : 'Unavailable or not permitted');
  }
  function recordSuccess(state) {
    if (!state.success || state.handled || !permission.ready) return;
    const pending = read('sessionStorage', state.key);
    if (!fresh(pending, PENDING_TTL) || pending.type !== state.type || !/^NQ-[a-z0-9-]+$/i.test(pending.id || '')) return;
    // Consume before queuing: refresh/back/another script execution cannot count the same submission twice.
    remove('sessionStorage', state.key);
    state.handled = true;
    if (!permission.analytics) { state.marker.setAttribute('data-notcoy-event-status', 'consent-blocked'); return; }
    const eventName = state.type === 'custom_rug' ? 'custom_rug_inquiry' : 'contact_inquiry';
    const payload = {
      send_to: 'G-X9H25WS9M4',
      inquiry_id: pending.id,
      inquiry_type: state.type,
      rug_handle: handle(pending.rug),
      form_id: state.form.id,
      page_location: location.origin + location.pathname,
      page_referrer: referrerHost() ? 'https://' + referrerHost() + '/' : ''
    };
    const send = typeof window.gtag === 'function' ? window.gtag : function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(arguments);
    };
    send('event', eventName, payload);
    state.marker.setAttribute('data-notcoy-event-status', 'queued');
  }
  function updatePermissions() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      if (!privacy) return;
      permission = {
        analytics: privacy.analyticsProcessingAllowed() === true,
        marketing: privacy.marketingAllowed() === true,
        sharing: privacy.saleOfDataAllowed() === true,
        ready: true
      };
    } catch (_) { return; }
    captureSource();
    forms.forEach(state => { fill(state); recordSuccess(state); });
    document.documentElement.setAttribute('data-notcoy-inquiry-consent', 'ready');
  }
  // Carry public product context in the existing custom-rug links, including links opened in a new tab.
  const productHandle = handle(script.getAttribute('data-product-handle'));
  if (productHandle) {
    document.querySelectorAll('a[href*="/pages/custom-rugs"]').forEach(link => {
      try {
        const url = new URL(link.getAttribute('href'), location.origin);
        if (!/(^|\.)notcoy\.(com|co)$/i.test(url.hostname) || !/\/pages\/custom-rugs\/?$/.test(url.pathname)) return;
        url.searchParams.set('rug', productHandle);
        link.href = url.toString();
      } catch (_) {}
    });
  }
  document.querySelectorAll('[data-notcoy-inquiry-form]').forEach(marker => {
    const form = marker.closest('form');
    if (!form) return;
    const key = PREFIX + 'pending_' + form.id;
    const pending = read('sessionStorage', key);
    const success = marker.getAttribute('data-notcoy-submitted') === 'true';
    const state = {
      form, marker, key, success, handled: false,
      type: marker.getAttribute('data-notcoy-inquiry-type') === 'custom_rug' ? 'custom_rug' : 'contact',
      id: !success && fresh(pending, PENDING_TTL) ? pending.id : inquiryId(),
      rug: handle(params.get('rug')) || (!success && fresh(pending, PENDING_TTL) ? handle(pending.rug) : '')
    };
    forms.push(state);
    fill(state);
    form.addEventListener('submit', () => {
      // Never interrupt Shopify validation, CAPTCHA, submission, or email delivery.
      updatePermissions();
      fill(state);
      field(form, 'Submitted at UTC', new Date().toISOString());
      write('sessionStorage', key, { id: state.id, rug: state.rug, type: state.type, time: Date.now() });
    });
    marker.setAttribute('data-notcoy-tracking-status', 'ready');
  });
  document.addEventListener('visitorConsentCollected', updatePermissions);
  updatePermissions();
  if (!permission.ready && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) updatePermissions(); });
  }
})();
